export default "__VITE_ASSET__DTZxEhZb__"